<div class="dashboard-container">
    <div class="sidebar">
        <div class="menu-divider">
            <div class="logo">
                <img src="assets/icons/pitts.svg" class="icon-red" [alt]="'shell.logoAlt' | transloco">
            </div>
            <app-quick-menu [user]="currentUser" [currentPlan]="currentPlan"></app-quick-menu>

            <div class="menu-items">
                <app-element-menu-dash [value]="'nav.main' | transloco" [path]="'main'" [active]="activeMenu" [locked]="!subscriptionActive" (menuClick)="goTo($event.path)"></app-element-menu-dash>
                <app-element-menu-dash [value]="'nav.drivers' | transloco" [path]="'drivers'" [icon]="'pi pi-id-card'" [active]="activeMenu" [locked]="!subscriptionActive" (menuClick)="goTo($event.path)"></app-element-menu-dash>
                <app-element-menu-dash [value]="'nav.vehicles' | transloco" [path]="'vehicles'" [icon]="'pi pi-car'" [active]="activeMenu" [locked]="!subscriptionActive" (menuClick)="goTo($event.path)"></app-element-menu-dash>
                <app-element-menu-dash [value]="'nav.salud' | transloco" [path]="'salud'" [icon]="'pi pi-heart'" [active]="activeMenu" [locked]="!subscriptionActive" (menuClick)="goTo($event.path)"></app-element-menu-dash>
                <app-element-menu-dash [value]="'nav.repuestos' | transloco" [path]="'repuestos'" [icon]="'pi pi-wrench'" [active]="activeMenu" (menuClick)="goTo($event.path)"></app-element-menu-dash>
                <app-element-menu-dash [value]="'nav.benefits' | transloco" [path]="'benefits'" [icon]="'pi pi-sparkles'" [active]="activeMenu" [locked]="!subscriptionActive" (menuClick)="goTo($event.path)"></app-element-menu-dash>
                <app-element-menu-dash
                    [value]="'nav.reports' | transloco"
                    [icon]="'pi pi-clipboard'"
                    [locked]="!subscriptionActive"
                    [subItems]="[
                        { value: ('nav.reportsGeneral' | transloco), path: ['reports','general'], icon: 'pi pi-home' },
                        { value: ('nav.reportsByVehicle' | transloco), path: ['reports','vehicle'], icon: 'pi pi-car' },
                        { value: ('nav.reportsByService' | transloco), path: ['reports','services'], icon: 'pi pi-pen-to-square' },
                        { value: ('nav.reportsByGeographic' | transloco), path: ['reports','geographic'], icon: 'pi pi-map' },
                        { value: ('nav.reportsByPartner' | transloco), path: ['reports','partner'], icon: 'pi pi-user' }
                    ]"
                    [active]="activeMenu"
                    (menuClick)="goTo($event.path)">
                </app-element-menu-dash>
                <app-element-menu-dash [value]="'nav.scheduling' | transloco" [path]="'scheduling'" [icon]="'pi pi-calendar'" [active]="activeMenu" [locked]="!subscriptionActive" (menuClick)="goTo($event.path)"></app-element-menu-dash>
                <app-element-menu-dash [value]="'nav.transactions' | transloco" [path]="'transactions'" [icon]="'pi pi-money-bill'" [active]="activeMenu" [locked]="!subscriptionActive" (menuClick)="goTo($event.path)"></app-element-menu-dash>
            </div>
        </div>

        <div class="menu-divider">
            <app-plan-view (menuClick)="goTo(['plan'])" [plan]="currentPlan" [currentPlan]="currentUser?.corporatePlan ?? null"></app-plan-view>

            <div class="menu-items menu-footer">
                <app-lang-switcher variant="menuItem"></app-lang-switcher>
                <app-element-menu-dash [value]="'nav.darkMode' | transloco" [icon]="'pi pi-moon'" (menuClick)="toggleDarkMode()" [type]="'switch'"></app-element-menu-dash>
                <!-- <app-element-menu-dash [value]="'Configuración'" [path]="'settings'" [icon]="'pi pi-cog'"></app-element-menu-dash> -->
                <app-element-menu-dash [value]="'nav.help' | transloco" [path]="'help'" [icon]="'pi pi-question-circle'" (menuClick)="openHelpEmail()"></app-element-menu-dash>
            </div>
        </div>
    </div>
    <div class="main-content">
        <!-- Trial banner -->
        <div class="trial-banner"
             *ngIf="currentPlan?.isTrial && currentPlan?.isActive"
             [class.trial-banner--warning]="(currentPlan?.trialTimeRemaining?.days ?? 99) <= 2"
             [class.trial-banner--danger]="(currentPlan?.trialTimeRemaining?.days ?? 99) < 1">
            <span class="trial-banner-text">
                <ng-container *ngIf="(currentPlan?.trialTimeRemaining?.days ?? 0) >= 1">
                    {{ (currentPlan?.trialTimeRemaining?.days === 1 ? 'shell.trialFreeDay' : 'shell.trialFreeDays') | transloco: { days: currentPlan?.trialTimeRemaining?.days } }}
                </ng-container>
                <ng-container *ngIf="(currentPlan?.trialTimeRemaining?.days ?? 0) < 1 && (currentPlan?.trialTimeRemaining?.hours ?? 0) >= 1">
                    {{ 'shell.trialExpiresToday' | transloco: { hours: currentPlan?.trialTimeRemaining?.hours } }}
                </ng-container>
                <ng-container *ngIf="(currentPlan?.trialTimeRemaining?.hours ?? 0) < 1">
                    {{ 'shell.trialExpiresSoon' | transloco }}
                </ng-container>
            </span>
            <button class="trial-banner-cta" (click)="goTo(['plan'])">{{ 'shell.viewPlans' | transloco }}</button>
        </div>
        <div class="header">
            <div class="header-left">
                <span class="header-title">{{ (currentTitleKey ? ('titles.' + currentTitleKey) : 'shell.defaultTitle') | transloco }}{{ titleUserSuffix }}</span>
            </div>
            <!-- <div class="header-right">
                <i class="pi pi-bell"></i>
            </div> -->
        </div>
        <div class="content">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>

<!-- Juana disponible en cualquier pantalla del dashboard. Va acá, fuera del
     <router-outlet>, para que persista entre rutas sin declararla en cada
     módulo hijo (PLAN-Pitts-Juana-General-FRONT.md §4.5). Ella misma se oculta
     donde ya está presente: Repuestos (panel fijo) y el home. -->
<app-juana-widget></app-juana-widget>

<button *ngIf="!environment.production && showDebugBarButton" pButton type="button" label=">" class="p-button-sm" (click)="hideDebugBar()" class="p-button-debug"></button>